import { V } from '@angular/cdk/keycodes';
import { ChangeDetectorRef, Component, Input, Inject, OnDestroy, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app/services/common.service';
import { NgxUiLoaderService } from "ngx-ui-loader";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-caseclaim',
  templateUrl: './caseclaim.component.html',
  styleUrls: ['./caseclaim.component.scss']
})
export class CaseclaimComponent implements OnInit, OnDestroy {
caseclaimdetails:any[]=[];
islabadmin:boolean;
isexpanded:boolean;
private destroy$ = new Subject<void>();

constructor(
  private service: CommonService,
  private ngxUiLoaderService: NgxUiLoaderService,
  private toastr: ToastrService,
  private cdr: ChangeDetectorRef,
  @Inject('caseData') public CaseDetails: any
){
  this.caseclaimdetails=this.CaseDetails?.CaseClaims?.Claim || [];
}
ngOnInit() {
  this.islabadmin=this.CaseDetails['islabadmin'];
  this.service.timezoneChanged$.pipe(takeUntil(this.destroy$)).subscribe(() => {
    this.cdr.markForCheck();
  });
let labguid=this.CaseDetails["ServiceProvider"]['Type']=='Laboratory'?this.CaseDetails["ServiceProvider"]['Location']['OrganizationGUID']:''
let obj={
 "CaseGUID": this.CaseDetails["CaseGUID"], 
 "DeploymentKey": this.CaseDetails["DeploymentKey"] , 
 "LabGUID":labguid
}
this.getCaseClaimDetails(obj);
}

ngOnDestroy(): void {
  this.destroy$.next();
  this.destroy$.complete();
}

formatClaimDate(datetime: string | null | undefined): string {
  if (!datetime) {
    return '';
  }
  if (!this.service.isHubApplication()) {
    return datetime;
  }
  return this.service.formatDateTimeForDisplay(
    datetime,
    'MM/dd/yyyy HH:mm:ss',
    this.service.logsApiTimezone
  );
}
getCaseClaimDetails(obj){
  this.ngxUiLoaderService.start();
this.service.GetCaseClaimDetails(obj).subscribe((data:any)=>{
  this.ngxUiLoaderService.stop();
  if(data!=null){
      if(data['Status'].toLowerCase()!='success'){
        if(this.caseclaimdetails.length==0){
        this.toastr.warning(data['Message'], "", {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
      }else{
        this.sortClaims(this.caseclaimdetails);
      }
      }else{
        if(data['Data']==null || (data['Data'][0]['ClaimNumber']==null && data['Data'][0]['AccessionNumber']==null)){
          if(this.caseclaimdetails.length==0){
          this.toastr.warning("Case Claims Not Found", "", {
            timeOut: 4000,
            positionClass: 'toast-bottom-right'
          });
        }else{
          this.sortClaims(this.caseclaimdetails);
        }
        }else{
        this.sortClaims(data['Data']);
      }
      }
  }
})
}
sortClaims(claim:any){
  if(Array.isArray(claim)){
    this.caseclaimdetails=claim;
  }
  else{
    this.caseclaimdetails=[claim];
  }
  this.caseclaimdetails.forEach(V=>{
          V['MilestoneDetails'].sort((a,b)=>a.Sequence-b.Sequence);
        });
}
expand(){
  this.isexpanded=!this.isexpanded;
}
}
